function Vision() {
  return (
    <div className="expertise-container" id="vision">
      <div className="skills-container">
        <h1 className="section-title">Vision</h1>

        <div className="vision-content">
          <p>
            Our vision is to develop AI systems that can reason, explain, comply with norms,
            and operate responsibly in real-world settings by combining formal reasoning,
            computational law and machine ethics, and trustworthy AI.
          </p>
        </div>

      </div>
    </div>
  );
}

export default Vision;